import React from "react";

const ALL_FORM_TYPES = ["dispatch", "driver_verification"];

const FormFilters = ({
   formTypeFilter,
   conversationIdFilter,
   errorStatusFilter = "",
   onFormTypeChange,
   onConversationIdSubmit,
   onErrorStatusChange,
   onClearFilters,
   isCompact = false,
}) => {
   return (
      <div
         className={`form-filters-container ${isCompact ? "compact" : ""}`}
         style={{
            zIndex: 100,
            borderBottom: isCompact ? "1px solid #e5e7eb" : "none",
         }}
      >
         <div className="form-filters-bar">
            {/* Form Type Filter */}
            <div className="filter-group">
               <label htmlFor="form_type" className="filter-label">
                  Form Type
               </label>
               <select
                  className="filter-select"
                  id="form_type"
                  value={formTypeFilter}
                  onChange={onFormTypeChange}
               >
                  <option value="">All Types</option>
                  {ALL_FORM_TYPES.map((type) => (
                     <option key={type} value={type}>
                        {type.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}
                     </option>
                  ))}
               </select>
            </div>

            {/* Error Status Filter */}
            <div className="filter-group">
               <label htmlFor="error_status" className="filter-label">
                  Error Status
               </label>
               <select
                  className="filter-select"
                  id="error_status"
                  value={errorStatusFilter}
                  onChange={onErrorStatusChange}
               >
                  <option value="">All Forms</option>
                  <option value="with_errors">With Errors</option>
                  <option value="without_errors">Without Errors</option>
               </select>
            </div>

            {/* Conversation ID Filter */}
            <form onSubmit={onConversationIdSubmit} className="filter-group conversation-filter">
               <label htmlFor="conversation_id" className="filter-label">
                  Conversation ID
               </label>
               <div className="conversation-input-group">
                  <input
                     type="text"
                     className="filter-input"
                     id="conversation_id"
                     name="conversation_id"
                     placeholder="Search by ID"
                     defaultValue={conversationIdFilter}
                  />
                  <button type="submit" className="filter-search-btn">
                     <i className="bi bi-search"></i>
                  </button>
               </div>
            </form>

            {/* Clear Filters Button */}
            {(formTypeFilter || conversationIdFilter || errorStatusFilter) && (
               <div className="filter-group clear-filter-group">
                  <button type="button" onClick={onClearFilters} className="clear-filters-btn">
                     <i className="bi bi-x-circle"></i> Clear Filters
                  </button>
               </div>
            )}
         </div>
      </div>
   );
};

export default FormFilters;
